import QuestionLibraryBuilder from '../QuestionLibraryBuilder';
import Heading from './Heading';
import ConditionEvaluatorContainer from './utilityComponents/ConditionEvaluator';
import ContentWrapper from './utilityComponents/ContentWrapper';

type SectionProps = {
  component?: any;
};

export default function Section({ component }: Readonly<SectionProps>) {
  const {
    name,
    title = '',
    placeholders = [],
    headingSize = 'large',
    conditions = {},
    children,
    hasBottomBorder = false,
    padding = '0',
    isPlainHeading = false,
  } = component;
  return (
    <ConditionEvaluatorContainer conditions={conditions}>
      <ContentWrapper hasBottomBorder={hasBottomBorder} padding={padding}>
        {title && (
          <Heading
            text={title}
            placeholders={placeholders}
            id={`${name}-heading`}
            testId={`${name}-heading`}
            headingSize={headingSize}
            isPlain={isPlainHeading}
            isCompact={isPlainHeading}
          />
        )}
        <QuestionLibraryBuilder questions={children} />
      </ContentWrapper>
    </ConditionEvaluatorContainer>
  );
}
